export const FEATURE_OVERRIDE_ENABLED = "featureOverrideEnabled";
export const FEATURE_AB_TESTING = "ab";
export const FEATURE_TEST_TOGGLE = "test_toggle";
export const FEATURE_NEW_RELIC = "newrelic";
export const FEATURE_ELECTRIC_OWNERSHIP = "electricownership";
